import useWindowDimensions from 'hooks/use-window-dimensions';

export default function useIsMobile(): boolean {
  const { width } = useWindowDimensions();
  return width <= 768;
}
